export default __webpack_public_path__ + "static/media/Ubosqueyfecoer.f5d2550f.png";